<template>
  <div class="content-block">
    <ResourceDetail
      :resourceId="resourceId"
      @done="onDone"
    ></ResourceDetail>
  </div>
</template>

<script>
import ResourceDetail from 'CORE/components/resource/detail'
import isString from 'lodash/isString'
import get from 'lodash/get'

export default {
    name: 'ResourceEditView',
    components: {
        ResourceDetail,
    },
    computed: {
        resourceId() {
            const id = get(this.$route.params, 'id')
            console.assert(isString(id), `ID must be a string`) // TODO check if id is valid uuid or not
            return id
        },
    },
    methods: {
        onDone() {
            this.$router.push({ name: 'resourcesList', params: { status: '$active' } })
        },
    },
}
</script>

